<template>
  <v-container v-if="RBAC_system_CAN_DEPLOY">
    <v-row justify="center">
      <v-col md="8" cols="12">
        <v-row v-if="systemInfo" align="end" justify="space-between">
          <v-col md="5" cols="12">
            <v-simple-table>
              <tbody>
                <tr>
                  <td>{{ $t("system_version") }}</td>
                  <td>{{ systemInfo.custId }} - {{ systemInfo.version }}</td>
                </tr>
                <tr>
                  <td>{{ $t("used_space") }}</td>
                  <td>
                    {{ systemInfo.usedDbSizeMb }} /
                    {{ systemInfo.maxDbSizeMb }} Mb
                    <v-progress-linear
                      color="primary"
                      :value="
                        (systemInfo.usedDbSizeMb * 100) / systemInfo.maxDbSizeMb
                      "
                    ></v-progress-linear>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("admin_user") }}</td>
                  <td>{{ systemInfo.adminUser }}</td>
                </tr>
                <tr>
                  <td>{{ $t("system_env") }}</td>
                  <td>
                    <v-icon
                      :color="systemInfo.ifTest == 1 ? 'warning' : 'success'"
                      >{{
                        systemInfo.ifTest == 1 ? "mdi-test-tube" : "mdi-vuetify"
                      }}</v-icon
                    >
                    {{ systemInfo.ifTest == 1 ? $t("test") : $t("production") }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>

          <v-col md="5" cols="12">
            <v-simple-table>
              <tbody>
                <tr>
                  <td>{{ $t("ragSoc") }}</td>
                  <td>{{ systemInfo.ragSoc }}</td>
                </tr>
                <tr>
                  <td>{{ $t("ref_person") }}</td>
                  <td>{{ systemInfo.refNome }}</td>
                </tr>
                <tr>
                  <td>{{ $t("telephone") }}</td>
                  <td>{{ systemInfo.refTel }}</td>
                </tr>
                <tr>
                  <td>{{ $t("email") }}</td>
                  <td>{{ systemInfo.refEmail }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col cols="12">
            <DataTables
              :showFooter="false"
              :showSearch="false"
              v-if="systemInfo && systemInfo.modules"
              :headers="headers"
              :table-data="systemInfo.modules"
              hide-default-footer
              class="elevation-1"
            ></DataTables>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";

export default {
  name: "deploy-instance",
  components: {
    DataTables,
  },
  data() {
    return {
      progress_restore: null,
      esito_restore: null,
      RBAC_system_CAN_DEPLOY: false,
      systemInfo: null,
      headers: [
        { text: this.$t("module"), value: "module", type: "text" },
        { text: this.$t("description"), value: "description", type: "text" },
        { text: this.$t("expire_date"), value: "expireDate", type: "date" },
        { text: this.$t("status"), value: "status", type: "icons" },
      ],
    };
  },
  methods: {
    loadData() {
      let _ = this;
      _.chiamataAxios("GET", "/auth/portal/getSystemStatus").then(
        (response) => {
          _.systemInfo = response.data;
          _.systemInfo.modules = _.systemInfo.modules.map((modulo) => {
            let minutes = 1000 * 60;
            let hours = minutes * 60;
            let days = hours * 24;

            let diff_date = Math.round(
              (new Date(modulo.expireDate) - new Date()) / days
            );
            let status = [
              {
                icon: "mdi-check-bold",
                color: "green",
                text: diff_date + " " + _.$t("days_remaining"),
              },
            ];
            if (diff_date < 30)
              status = [
                {
                  icon: "mdi-alert",
                  color: "warning",
                  text: diff_date + " " + _.$t("days_remaining"),
                },
              ];
            if (diff_date < 0)
              status = [
                {
                  icon: "mdi-close-thick",
                  color: "error",
                  text: _.$t("expired"),
                },
              ];
            modulo.status = status;
            return modulo;
          });
        }
      );
    },
  },
  mounted() {
    this.loadData();
    this.RBAC_system_CAN_DEPLOY = this.checkUserRole("system", "CAN_DEPLOY");
  },
};
</script>